/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Form, Input, Button } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import IconLogo from '../../assets/Images/icons/icon-logo';
import { useTranslation } from 'react-i18next';
import AuthService from '../../services/Auth.service';

const authService = new AuthService();

export default function ResetForm(props) {
    const [loading, setLoading] = useState(false);

    const { i18n, t } = useTranslation();

    const [form] = Form.useForm();

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const { data } = await authService.forgotPassword({
                email: values.email,
            });
            if (data.resultMsg === 'SUCCESS') {
                props.setCurrentPageAction({
                    name: 'SUCCESS',
                    mail: values.email,
                    text: 'RESETMAIL',
                });
            }
        } catch (err) {
            console.log(err);
            const errorMsg =
                err.data?.errorData?.msg === 'USER IS DISABLED'
                    ? i18n.language === 'en'
                        ? 'This email has been disabled. Password reset is not allowed.'
                        : 'อีเมลนี้ถูกปิดการใช้งาน ไม่อนุญาตให้รีเซ็ตรหัสผ่าน'
                    : i18n.language === 'en'
                    ? 'This email user could not be found.'
                    : 'ไม่พบผู้ใช้อีเมล์นี้';
            form.setFields([
                {
                    name: 'email',
                    errors: [errorMsg],
                },
            ]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        try {
            if (localStorage.getItem('Remember') === 'true') {
                form.setFieldsValue({
                    username: localStorage.getItem('username'),
                    password: localStorage.getItem('password'),
                });
            }
            localStorage.removeItem('Remember');
        } catch (err) {
            console.log(err);
        }
    }, []);

    return (
        <div className="justify-center">
            <div
                className="text-4xl mt-8 mb-2 "
                style={{ color: '#A8A8AF', textAlign: 'center' }}
            >
                <IconLogo />
            </div>
            <div
                className="text-2xl  mb-4 pt-10"
                style={{
                    textAlign: 'center',
                    fontSize: '16px',
                    fontWeight: 600,
                }}
            >
                <span>{t('Reset Password')}</span>
            </div>
            <Form
                form={form}
                className="pl-16 pr-16"
                layout="vertical"
                onFinish={onFinish}
                requiredMark={'optional'}
            >
                <Form.Item
                    name="email"
                    // label={<span className="text-xl font-medium">Username</span>}
                    className="mb-8 pb-6"
                    rules={[
                        {
                            required: true,
                            message: t('userManagement.EmailIsRequired'),
                        },
                    ]}
                >
                    <Input
                        style={{ backgroundColor: '#f5f6ff' }}
                        prefix={<MailOutlined />}
                        className="rounded-lg"
                        size="large"
                        placeholder={t('Email Address')}
                    />
                </Form.Item>

                <Form.Item className="flex justify-center mb-4 mt-10 pt-10">
                    <Button
                        className="w-full flex items-center justify-center"
                        style={{
                            color: '#fff',
                            backgroundColor: '#7B67FB',
                            borderRadius: '7px',
                        }}
                        size="large"
                        loading={loading}
                        htmlType="submit"
                    >
                        {t('Continue')}
                    </Button>
                </Form.Item>

                <button
                    type="button"
                    className="cursor-pointer hover:opacity-80 text-center w-full"
                    style={{ textAlign: 'center', color: '#1890FF' }}
                    onClick={() =>
                        props.setCurrentPageAction({
                            name: 'LOGIN',
                            mail: '',
                            text: '',
                        })
                    }
                >
                    {t('Back to login')}
                </button>
            </Form>
        </div>
    );
}
